import React from 'react';
import {get, orderBy} from 'lodash';
import {gql} from 'apollo-boost';

import client from '../../../../src/graphql/client';

import refractorVariantData from '../../../../src/data-restructure/build-and-price/variant';
import ModelStepOnePage from '../../../../src/containers/ModelStepOnePage';


const BuildPriceStepOnePage = (props) => {
  return (
    <ModelStepOnePage
      {...props}
    />
  )
}


export async function getStaticPaths() {

  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
      series(where: {status: PUBLISH}, first: 1000) {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const series = get(result, 'data.series.nodes', []);
  let paths = [];
  
  const filteredSeries = series.filter((item) => {
    // filter out if doesn't have uri
    return item.uri
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  filteredSeries.forEach(series => {
    const assignedDomains = get(series, 'acf_domains.assignedDomains', []);
    assignedDomains.indexOf(domain) !== -1 && series.uri != 'new-models' && paths.push({
      params: {
        series: `${series.uri}`
      }
    });
  })

  return { paths , fallback: false }
}


export async function getStaticProps(context) {
  return refractorVariantData(context);
}


export default BuildPriceStepOnePage
  
